


import React, {Component} from 'react'

var saleContextUtil = require('../../utils/saleContextUtil.js');

class Category extends Component 
{
    render()
    {
        var backGroundColor = this.props.category.backgroundColor;
        var foreColor = this.props.category.foregroundColor;

        if (this.props.isSelected)
        {
            backGroundColor = this.props.category.selectedBackgroundColor;
            foreColor = this.props.category.selectedForegroundColor;
        }

        let onClick = null;
        if (this.props.category.enabled && !this.props.isSelected)
        {
            onClick = ()=>
            {
                let saleContext = saleContextUtil.getCurrentSaleContext();
                saleContext.selectedCategory = this.props.category;
                saleContextUtil.raiseSaleContextMenuChangeEvent();
            }
        }

        return  <div style={{ 
                            display:'flex',
                            justifyContent:'center',
                            alignItems:'center',
                            minWidth:'16.66%',
                            width:"auto",
                            padding:'1rem 2rem',
                            background:backGroundColor, color:foreColor,
                            borderRadius:"var(--button-roundness)",
                            fontWeight:'bold',
                            whiteSpace:'nowrap',
                            flexShrink:1,
                            flexGrow:1
                        }}
                    onClick={onClick}>
                    <div style={{textAlign:'center'}}>
                        {this.props.category.caption}
                    </div>
               </div>
    }
}

export default Category